(() => {
  const root = document.querySelector('.umbro-blueprint');
  if (!root) return;

  const mobileBuy = root.querySelector('[data-blueprint-mobile-buy]');
  const hero = root.querySelector('.ub-hero');

  if (mobileBuy && hero) {
    document.body.appendChild(mobileBuy);

    let stickyTicking = false;

    const syncMobileBuy = () => {
      stickyTicking = false;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const pastHero = hero.getBoundingClientRect().bottom <= 8;
      const shouldShow = isMobile && pastHero;

      mobileBuy.classList.toggle('is-visible', shouldShow);
      mobileBuy.setAttribute('aria-hidden', String(!shouldShow));
    };

    const requestStickySync = () => {
      if (stickyTicking) return;
      stickyTicking = true;
      window.requestAnimationFrame(syncMobileBuy);
    };

    syncMobileBuy();
    window.addEventListener('scroll', requestStickySync, { passive: true });
    window.addEventListener('resize', requestStickySync, { passive: true });
  }

  const players = root.querySelectorAll('audio');
  players.forEach((player) => player.addEventListener('play', () => {
    players.forEach((other) => {
      if (other !== player && !other.paused) other.pause();
    });
  }));

  const videos = root.querySelectorAll('video[data-blueprint-video]');
  const warmup = (video) => {
    if (video.dataset.blueprintLoaded === 'true') return;
    video.dataset.blueprintLoaded = 'true';
    video.preload = 'auto';
    video.load();
  };
  const play = (video) => {
    warmup(video);
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  };
  if ('IntersectionObserver' in window) {
    const preloadObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const video = entry.target;
        warmup(video);
        observer.unobserve(video);
      });
    }, { rootMargin: '600px 0px' });
    const playbackObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) play(entry.target);
        else entry.target.pause();
      });
    }, { threshold: 0.01 });
    videos.forEach((video) => {
      preloadObserver.observe(video);
      playbackObserver.observe(video);
    });
  } else {
    videos.forEach(play);
  }

  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
  const sections = root.querySelectorAll('section:not(.ub-hero)');
  sections.forEach((section) => section.classList.add('ub-scroll-reveal'));
  if (!('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('ub-in-view'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('ub-in-view');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
  sections.forEach((section) => observer.observe(section));
})();
